module.exports = __webpack_public_path__ + "img/syo-logo.27664540.png";